// https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html
// import "@lib/third/jweixin-1.6.0.js";

/**
 * 信鸽停车微信服务号
 * appid      wxdb8468d8262792d3
 * appsecret  296cf699a5a7caf535c50a22a9c99a29
 *
 * 卓能微信服务号
 * appid      wxcc4645ca16ab0a43
 * appsecret  0f35ef010de126b71817e88f026c3909
 *
 * 信鸽停车微信小程序
 * appid  wx9e3fd78a7b00b202
 *
 * 卓能微信小程序
 * appid  wx8f38e0d03cf5da91
 */

declare const document: Document & {
  attachEvent: any;
  createEventObject: any;
};

import { trimHash } from "@zyzgroup/core-common";

type wxConfig = {
  appId: string; // 必填，公众号的唯一标识
  timestamp: string; // 必填，生成签名的时间戳
  nonceStr: string; // 必填，生成签名的随机串
  signature: string; // 必填，签名

  debug: boolean; // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
  jsApiList: string[]; // 必填，需要使用的JS接口列表
};

type wxConfigFromServer = Omit<wxConfig, "debug" | "jsApiList">;

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace wx {
  function config(config: wxConfig): void;
  function ready(cb: () => void): void;
  function error(cb: (res: any) => void): void;
  function checkJsApi(config: {
    jsApiList: string[]; // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: (res: {
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      checkResult: Record<string, boolean>;
      errMsg: string;
    }) => void;
    fail?: (res: any) => void;
  }): void;
  function updateAppMessageShareData(shareConfig: {
    title: string; // 分享标题
    desc: string; // 分享描述
    link: string; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: string; // 分享图标
    success: () => void; // 设置成功
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function updateTimelineShareData(shareConfig: {
    title: string; // 分享标题
    link: string; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: string; // 分享图标
    success: () => void; // 设置成功
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function chooseImage(apiConfig: {
    count: number; // 默认9
    sizeType: ["original", "compressed"] | ["original"] | ["compressed"]; // 可以指定是原图还是压缩图，默认二者都有
    sourceType: ["album", "camera"] | ["album"] | ["camera"]; // 可以指定来源是相册还是相机，默认二者都有
    success: (res: {
      localIds: string[]; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function previewImage(apiConfig: {
    current: string; // 当前显示图片的http链接
    urls: string[]; // 需要预览的图片http链接列表
  }): void;
  function uploadImage(apiConfig: {
    localId: string; // 需要上传的图片的本地ID，由chooseImage接口获得
    isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
    success: (res: {
      serverId: string; // 返回图片的服务器端ID
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function downloadImage(apiConfig: {
    serverId: string; // 需要下载的图片的服务器端ID，由uploadImage接口获得
    isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
    success: (res: {
      localId: string; // 返回图片下载后的本地ID
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function getLocalImgData(apiConfig: {
    localId: string; // 图片的localID
    success: (res: {
      localData: string; // localData是图片的base64数据，可以用img标签显示
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function startRecord(): void;
  function stopRecord(apiConfig: {
    success: (res: { localId: string }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function onVoiceRecordEnd(apiConfig: {
    // 录音时间超过一分钟没有停止的时候会执行 complete 回调
    complete: (res: { localId: string }) => void;
  }): void;
  function playVoice(apiConfig: {
    localId: string; // 需要播放的音频的本地ID，由stopRecord接口获得
  }): void;
  function pauseVoice(apiConfig: {
    localId: string; // 需要暂停的音频的本地ID，由stopRecord接口获得
  }): void;
  function stopVoice(apiConfig: {
    localId: string; // 需要停止的音频的本地ID，由stopRecord接口获得
  }): void;
  function onVoicePlayEnd(apiConfig: {
    success: (res: {
      localId: string; // 返回音频的本地ID
    }) => void;
  }): void;
  function uploadVoice(apiConfig: {
    localId: string; // 需要上传的音频的本地ID，由stopRecord接口获得
    isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
    success: (res: {
      serverId: string; // 返回音频的服务器端ID
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function downloadVoice(apiConfig: {
    serverId: string; // 需要下载的音频的服务器端ID，由uploadVoice接口获得
    isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
    success: (res: {
      localId: string; // 返回音频的本地ID
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function translateVoice(apiConfig: {
    localId: string; // 需要识别的音频的本地Id，由录音相关接口获得
    isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
    success: (res: {
      translateResult: string; // 语音识别的结果
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function getNetworkType(apiConfig: {
    success: (res: {
      networkType: string; // 返回网络类型2g，3g，4g，wifi
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function openLocation(apiConfig: {
    latitude: number; // 纬度，浮点数，范围为90 ~ -90
    longitude: number; // 经度，浮点数，范围为180 ~ -180。
    name: string; // 位置名
    address: string; // 地址详情说明
    scale: number; // 地图缩放级别,整型值,范围从1~28。默认为最大
    infoUrl: string; // 在查看位置界面底部显示的超链接,可点击跳转
  }): void;
  function getLocation(apiConfig: {
    type: "wgs84" | "gcj02"; // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    success: (res: {
      latitude: number; // 纬度，浮点数，范围为90 ~ -90
      longitude: number; // 经度，浮点数，范围为180 ~ -180。
      speed: number; // 速度，以米/每秒计
      accuracy: number; // 位置精度
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
  function scanQRCode(apiConfig: {
    needResult: 0 | 1; // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    scanType: ["qrCode", "barCode"] | ["qrCode"] | ["barCode"]; // 可以指定扫二维码还是一维码，默认二者都有
    success: (res: {
      resultStr: string; // 当needResult 为 1 时，扫码返回的结果
    }) => void;
    fail?: (res: { errMsg: string }) => void;
  }): void;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace WeixinJSBridge {
  function invoke(
    method: "getBrandWCPayRequest",
    config: {
      appId: string; // 公众号ID
      timeStamp: string; // 时间戳，自1970年以来的秒数
      nonceStr: string; // 随机串
      package: string;
      signType: string; // 微信签名方式
      paySign: string; // 微信签名
    },
    cb: (res: { err_msg: string }) => void
  ): void;
}

const initWxJsReadyFns: (() => void)[] = [];
const initWxJsConfigRecord: Record<string, boolean> = {};

export function addWxJsReadyFnBeforeConfig(fn: () => void) {
  initWxJsReadyFns.push(fn);
}

// 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
// 同一个url仅需调用一次，对于变化url的SPA的web app可在每次url变化时进行调用
// 目前Android微信客户端不支持pushState的H5新特性，所以使用pushState来实现web app的页面会导致签名失败，此问题会在Android6.2中修复
export function injectWxJsConfig(
  configFromServer: wxConfigFromServer,
  debug = false
) {
  // 不包含#hash
  const currentURL = trimHash();
  if (initWxJsConfigRecord[currentURL]) {
    return;
  }
  // config信息验证失败会执行error函数，如签名过期导致验证失败，
  // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
  wx.error((res) => {
    console.log(res.errMsg || JSON.stringify(res));
  });
  // config信息验证后会执行ready方法
  // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
  // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
  wx.ready(() => {
    initWxJsReadyFns.forEach((fn) => fn());
  });
  const ALL_WX_JS_APIS = [
    "updateAppMessageShareData",
    "updateTimelineShareData",
    "onMenuShareWeibo",
    "onMenuShareQZone",
    "startRecord",
    "stopRecord",
    "onVoiceRecordEnd",
    "playVoice",
    "pauseVoice",
    "stopVoice",
    "onVoicePlayEnd",
    "uploadVoice",
    "downloadVoice",
    "chooseImage",
    "previewImage",
    "uploadImage",
    "downloadImage",
    "getLocalImgData",
    "translateVoice",
    "getNetworkType",
    "openLocation",
    "getLocation",
    "hideOptionMenu",
    "showOptionMenu",
    "hideMenuItems",
    "showMenuItems",
    "hideAllNonBaseMenuItem",
    "showAllNonBaseMenuItem",
    "closeWindow",
    "scanQRCode",
    "openProductSpecificView",
    "addCard",
    "chooseCard",
    "openCard"
  ];
  // 需要使用的开放标签列表
  const ALL_WX_OPEN_TAGS = [
    "wx-open-launch-app",
    "wx-open-launch-app",
    "wx-open-subscribe",
    "wx-open-audio"
  ];
  // 所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作
  wx.config(
    Object.assign(configFromServer, {
      debug,
      jsApiList: ALL_WX_JS_APIS,
      openTagList: ALL_WX_OPEN_TAGS
    }) as wxConfig
  );
  initWxJsConfigRecord[currentURL] = true;
}

// checkJsApi接口是客户端6.0.2新引入的一个预留接口，第一期开放的接口均可不使用checkJsApi来检测
export function checkWxJsApi(apiName: string) {
  return new Promise<boolean>((resolve, reject) => {
    wx.checkJsApi({
      jsApiList: [apiName],
      success: function (res) {
        if (res.checkResult[apiName]) {
          resolve(true);
        } else {
          reject(false);
        }
      },
      fail: function () {
        reject(false);
      }
    });
  });
}

// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
export function wxJsUpdateAppMessageShareData(shareConfig: {
  title: string; // 分享标题
  desc: string; // 分享描述
  link: string; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: string; // 分享图标
  success: () => void; // 设置成功
  ffail?: (res: { errMsg: string }) => void;
}) {
  addWxJsReadyFnBeforeConfig(function () {
    wx.updateAppMessageShareData(shareConfig);
  });
}

// 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
export function wxJsUpdateTimelineShareData(shareConfig: {
  title: string; // 分享标题
  link: string; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: string; // 分享图标
  success: () => void; // 设置成功
  fail?: (res: { errMsg: string }) => void;
}) {
  addWxJsReadyFnBeforeConfig(function () {
    wx.updateTimelineShareData(shareConfig);
  });
}

// 拍照或从手机相册中选图接口
export function wxJsChooseImage(apiConfig: {
  count: number; // 默认9
  sizeType: ["original", "compressed"] | ["original"] | ["compressed"]; // 可以指定是原图还是压缩图，默认二者都有
  sourceType: ["album", "camera"] | ["album"] | ["camera"]; // 可以指定来源是相册还是相机，默认二者都有
  success: (res: {
    localIds: string[]; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.chooseImage(apiConfig);
}

// 预览图片接口
export function wxJsPreviewImage(apiConfig: {
  current: string; // 当前显示图片的http链接
  urls: string[]; // 需要预览的图片http链接列表
}) {
  wx.previewImage(apiConfig);
}

// 上传图片接口
// 备注：上传图片有效期3天，可用微信多媒体接口下载图片到自己的服务器，此处获得的 serverId 即 media_id。
export function wxJsUploadImage(apiConfig: {
  localId: string; // 需要上传的图片的本地ID，由chooseImage接口获得
  isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
  success: (res: {
    serverId: string; // 返回图片的服务器端ID
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.uploadImage(apiConfig);
}

// 下载图片接口
export function wxJsDownloadImage(apiConfig: {
  serverId: string; // 需要下载的图片的服务器端ID，由uploadImage接口获得
  isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
  success: (res: {
    localId: string; // 返回图片下载后的本地ID
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.downloadImage(apiConfig);
}

// 获取本地图片接口
// 备注：此接口仅在 iOS WKWebview 下提供，用于兼容 iOS WKWebview 不支持 localId 直接显示图片的问题。具体可参考《iOS WKWebview网页开发适配指南》
export function wxJsGetLocalImgData(apiConfig: {
  localId: string; // 图片的localID
  success: (res: {
    localData: string; // localData是图片的base64数据，可以用img标签显示
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.getLocalImgData(apiConfig);
}

// 开始录音接口
export function wxJsStartRecord() {
  wx.startRecord();
}

// 停止录音接口
export function wxJsStopRecord(apiConfig: {
  success: (res: { localId: string }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.stopRecord(apiConfig);
}

// 监听录音自动停止接口
export function wxJsOnVoiceRecordEnd(apiConfig: {
  // 录音时间超过一分钟没有停止的时候会执行 complete 回调
  complete: (res: { localId: string }) => void;
}) {
  wx.onVoiceRecordEnd(apiConfig);
}

// 播放语音接口
export function wxJsPlayVoice(apiConfig: {
  localId: string; // 需要播放的音频的本地ID，由stopRecord接口获得
}) {
  wx.playVoice(apiConfig);
}

// 暂停播放接口
export function wxJsPauseVoice(apiConfig: {
  localId: string; // 需要暂停的音频的本地ID，由stopRecord接口获得
}) {
  wx.pauseVoice(apiConfig);
}

// 停止播放接口
export function wxJsStopVoice(apiConfig: {
  localId: string; // 需要停止的音频的本地ID，由stopRecord接口获得
}) {
  wx.stopVoice(apiConfig);
}

// 监听语音播放完毕接口
export function wxJsOnVoicePlayEnd(apiConfig: {
  success: (res: {
    localId: string; // 返回音频的本地ID
  }) => void;
}) {
  wx.onVoicePlayEnd(apiConfig);
}

// 上传语音接口
// 备注：上传语音有效期3天，可用微信多媒体接口下载语音到自己的服务器，此处获得的 serverId 即 media_id，参考文档 .目前多媒体文件下载接口的频率限制为10000次/天，如需要调高频率，请登录微信公众平台，在开发 - 接口权限的列表中，申请提高临时上限。
export function wxJsUploadVoice(apiConfig: {
  localId: string; // 需要上传的音频的本地ID，由stopRecord接口获得
  isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
  success: (res: {
    serverId: string; // 返回音频的服务器端ID
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.uploadVoice(apiConfig);
}

// 下载语音接口
export function wxJsDownloadVoice(apiConfig: {
  serverId: string; // 需要下载的音频的服务器端ID，由uploadVoice接口获得
  isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
  success: (res: {
    localId: string; // 返回音频的本地ID
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.downloadVoice(apiConfig);
}

// 识别音频并返回识别结果接口
export function wxJsTranslateVoice(apiConfig: {
  localId: string; // 需要识别的音频的本地Id，由录音相关接口获得
  isShowProgressTips: 0 | 1; // 默认为1，显示进度提示
  success: (res: {
    translateResult: string; // 语音识别的结果
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.translateVoice(apiConfig);
}

// 获取网络状态接口
export function wxJsGetNetworkType(apiConfig: {
  success: (res: {
    networkType: string; // 返回网络类型2g，3g，4g，wifi
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.getNetworkType(apiConfig);
}

// 使用微信内置地图查看位置接口
export function wxJsOpenLocation(apiConfig: {
  latitude: number; // 纬度，浮点数，范围为90 ~ -90
  longitude: number; // 经度，浮点数，范围为180 ~ -180。
  name: string; // 位置名
  address: string; // 地址详情说明
  scale: number; // 地图缩放级别,整型值,范围从1~28。默认为最大
  infoUrl: string; // 在查看位置界面底部显示的超链接,可点击跳转
}) {
  wx.openLocation(apiConfig);
}

// 获取地理位置接口
export function wxJsGetLocation(apiConfig: {
  type: "wgs84" | "gcj02"; // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
  success: (res: {
    latitude: number; // 纬度，浮点数，范围为90 ~ -90
    longitude: number; // 经度，浮点数，范围为180 ~ -180。
    speed: number; // 速度，以米/每秒计
    accuracy: number; // 位置精度
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.getLocation(apiConfig);
}

// 调起微信扫一扫接口
export function wxJsScanQRCode(apiConfig: {
  needResult: 0 | 1; // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
  scanType: ["qrCode", "barCode"] | ["qrCode"] | ["barCode"]; // 可以指定扫二维码还是一维码，默认二者都有
  success: (res: {
    resultStr: string; // 当needResult 为 1 时，扫码返回的结果
  }) => void;
  fail?: (res: { errMsg: string }) => void;
}) {
  wx.scanQRCode(apiConfig);
}

// 微信支付
// 请参考微信支付文档，JSAPI调起支付API：https://pay.weixin.qq.com/wiki/doc/apiv3/apis/chapter3_1_4.shtml
// 备注：
// 微信支付V2的开发文档：https://pay.weixin.qq.com/wiki/doc/api/index.html
// 微信支付V3的开发文档：https://pay.weixin.qq.com/wiki/doc/apiv3/index.shtml
export function wxJsPay(
  config: {
    appId: string; // 公众号ID
    timeStamp: string; // 时间戳，自1970年以来的秒数
    nonceStr: string; // 随机串
    package: string;
    signType: string; // 微信签名方式
    paySign: string; // 微信签名
  },
  successCb: () => void,
  errorCb: (err_msg: string) => void
) {
  function onBridgeReady() {
    WeixinJSBridge.invoke("getBrandWCPayRequest", config, function (res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 微信团队郑重提示：
        // res.err_msg 将在用户支付成功后返回 ok，但并不保证它绝对可靠
        successCb();
      } else {
        errorCb(res.err_msg);
      }
    });
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
}

// 关闭当前网页窗口接口
// wx.closeWindow();

// 批量隐藏功能按钮接口
// wx.hideMenuItems({
//   menuList: [] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
// });

// 批量显示功能按钮接口
// wx.showMenuItems({
//   menuList: [] // 要显示的菜单项，所有menu项见附录3
// });

// 隐藏所有非基础按钮接口
// wx.hideAllNonBaseMenuItem();

// 显示所有功能按钮接口
// wx.showAllNonBaseMenuItem();

// 基本类
// 举报: "menuItem:exposeArticle"
// 调整字体: "menuItem:setFont"
// 日间模式: "menuItem:dayMode"
// 夜间模式: "menuItem:nightMode"
// 刷新: "menuItem:refresh"
// 查看公众号（已添加）: "menuItem:profile"
// 查看公众号（未添加）: "menuItem:addContact"

// 传播类
// 发送给朋友: "menuItem:share:appMessage"
// 分享到朋友圈: "menuItem:share:timeline"
// 分享到QQ: "menuItem:share:qq"
// 分享到Weibo: "menuItem:share:weiboApp"
// 收藏: "menuItem:favorite"
// 分享到FB: "menuItem:share:facebook"
// 分享到 QQ 空间 "menuItem:share:QZone"

// 保护类
// 编辑标签: "menuItem:editTag"
// 删除: "menuItem:delete"
// 复制链接: "menuItem:copyUrl"
// 原网页: "menuItem:originPage"
// 阅读模式: "menuItem:readMode"
// 在QQ浏览器中打开: "menuItem:openWithQQBrowser"
// 在Safari中打开: "menuItem:openWithSafari"
// 邮件: "menuItem:share:email"
// 一些特殊公众号: "menuItem:share:brand"

// UnionID
// https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html
// 需要前往微信开放平台（open.weixin.qq.com）绑定公众号后，才可利用UnionID
// 卓能：xl@ruolin-link.com
// 若临：third@ruolin-link.com

// 微信网页授权规范
// 授权流程需引导清晰、准确：在申请获取用户信息的弹窗出现前，应该清晰、准确地告知用户获取信息的范围及获取信息的目的；
// 必要场景申请：在必须获取用户信息时才申请，而不是用户尚未了解服务前就强制弹窗。如使用医院挂号时才需要获取用户信息；
// 不强制登录：提供游客模式，供用户了解网页提供的基础服务，不强制用户允许网页获取用户信息后才能使用网页服务。

// 常见的微信网页授权不规范使用案例
// 强制登录：在用户打开网页时立即要求用户授权，用户拒绝后无法使用网页提供的服务；
// 违规收集个人信息：未在网页提前告知使用个人信息的目的、方式和范围；
// 非必要收集：非必要获取用户信息的网页，如文章、视频等，要求用户在浏览内容前登录；
// 差别对待微信用户：同样的网页在浏览器内可以无需登录直接访问，在微信内却要求用户先登录才可访问。

// 如果用户同意授权，页面将跳转至 redirect_uri/?code=CODE&state=STATE
export function wxJsLogin(
  appid: string,
  redirect_uri: string,
  scope: "snsapi_base" | "snsapi_userinfo" = "snsapi_userinfo",
  state = ""
) {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
    redirect_uri
  )}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
}
